export const webConfig = {
  width: 1920,
  height: 1080,

  get applicationConfigs() {
    return {
      width: this.width,
      height: this.height,
    };
  },
  get staticAnimationsPosition() {
    return {
      x: this.width / 2,
      y: this.height / 2,
    };
  },
  buttonConfigs: {
    scale: 0.4,
    bluePigButton: {
      x: 700,
      y: 725,
    },
    yellowPigButton: {
      x: 900,
      y: 725,
    },
    redPigButton: {
      x: 500,
      y: 725,
    },
  },
  charactersConfigs: {
    scale: 1,
    wolf: {
      x: 220,
      y: 575,
    },
    whiteWolf: {
      x: 900,
      y: 880,
    },
    bluePig: {
      x: 700,
      y: 600,
    },
    redPig: {
      x: 850,
      y: 600,
    },
    yellowPig: {
      x: 1000,
      y: 600,
    },
  },
};

export const charactersMobileConfigs = {
  scale: 1,
  wolf: {
    x: 0,
    y: 0,
  },
  whiteWolf: {
    x: 100,
    y: 100,
  },
  bluePig: {
    x: 100,
    y: 100,
  },
  yellowPig: {
    x: 100,
    y: 100,
  },
  redPig: {
    x: 100,
    y: 100,
  },
};

export const timerWebConfig = {
  scale: 0.5,
  x: webConfig.width / 2 - 150,
  y: 500,
};
export const cashOutWebConfig = {
  scale: 0.5,
  x: webConfig.width / 2 + 150,
  y: 500,
};
